import Vue from 'vue';
import alice from '../../alice-api';

export default {
  namespaced: true,
  state: {
    user: {},
    userInfo: {},
  },
  getters: {
    user: (state) => state.user,
    role: (state) => {
      if (state.user) {
        return state.user.role;
      }
      const user = alice.getUser();
      if (user) {
        return user.role;
      }
      return '';
    },
    username: (state) => {
      if (state.user) {
        return state.user.username;
      }
      const user = alice.getUser();
      if (user) {
        return user.username;
      }
      return '';
    },
    userInfo: (state) => state.userInfo,
  },
  actions: {
    setUserData(context, data) {
      context.commit('setUserData', data);
    },
    loadUserInfo(context) {
      return new Promise((resolve, reject) => {
        alice
          .getUserInfo()
          .then((response) => {
            const { data } = response.data;
            context.commit('setUserInfoData', data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
  mutations: {
    setUserData(state, data) {
      Vue.set(state, 'user', data);
    },
    setUserInfoData(state, data) {
      Vue.set(state, 'userInfo', data);
    },
  },
};
